import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["password", "confirmation", "requirement", "submit"]

  declare readonly passwordTarget: HTMLInputElement
  declare readonly hasPasswordTarget: boolean
  declare readonly confirmationTarget: HTMLInputElement
  declare readonly hasConfirmationTarget: boolean
  declare readonly requirementTargets: HTMLElement[]
  declare readonly submitTarget: HTMLButtonElement
  declare readonly hasSubmitTarget: boolean

  connect() {
    this.validate()
  }

  validate() {
    const password = this.passwordTarget.value || ""
    const confirmation = this.hasConfirmationTarget ? this.confirmationTarget.value : ""
    
    const requirements: { [key: string]: boolean } = {
      length: password.length >= 8,
      number: /[0-9]/.test(password),
      uppercase: /[A-Z]/.test(password),
      special: /[!@#$%^&*(),.?":{}|<>]/.test(password),
      match: password.length > 0 && password === confirmation
    }

    this.requirementTargets.forEach(target => {
      const type = target.dataset.requirementType
      if (!type) return

      const isMet = requirements[type]
      
      if (isMet) {
        target.classList.add("is-met")
      } else {
        target.classList.remove("is-met")
      }
    })

    const allMet = Object.values(requirements).every(Boolean)
    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = !allMet
    }
  }
}
